import { el, list } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import MeetingAttendee from './attendee';

import {
  sortAttendees
} from './utilities';

import './index.scss';

class MeetingAttendees {

  constructor(activity) {

    this.list = list('#meeting-attendees-list', MeetingAttendee, '_id', this);

    this.list.update(sortAttendees(activity, application.getUser()), {
      event: activity.event,
      currentUser: application.getUser()
    });

    this.el = el('#meeting-attendees-main', [
      this.list
    ]);

  }

  async uninviteAttendee(attendee) {

    await serverInterface.startup.calendarActivities.meetings.uninviteAttendee(this.activity.event._id, attendee._id);

    const index = findIndexByPropertyValue(this.activity.event.attendees, '_id', attendee._id);

    this.activity.event.attendees.splice(index, 1);

    this.list.update(sortAttendees(this.activity, application.getUser()));

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: `${attendee.fullName} has been uninvited from this meeting.`,
      seconds: 5,
      type: 'info'
    });

  }

}

export default MeetingAttendees;